import Vue from 'vue';
import FormatterHelper from '@/scripts/helpers/formatter.helper.js'

Vue.filter('FormatMoney', (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
    return FormatterHelper.formatMoney(amount, decimalCount, decimal, thousands);
});